import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button, DialogActions, DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { handleDeleteOrgUser } from '@/component/system/handler/UserManagementHandler';
import './ConfirmDeleteOrgUserDialog.css';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ConfirmDeleteOrgUserDialog({argsAll}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const handleAgree = () => {
        if (!argsAll.isOpenDialogConfirmDelete.userId) {
            return;
        }

        if (argsAll.isOpenDialogConfirmDelete.isEnable && argsAll.isOpenDialogConfirmDelete.userId) {
            
            // Remove user in org
            handleDeleteOrgUser(argsAll, argsAll.isOpenDialogConfirmDelete.userId);
        }

        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    const handleDisagree = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    return (
        <Dialog
            open={argsAll.isOpenDialogConfirmDelete.isEnable}
            onClose={(event, reason) => handleDisagree(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-delete-addition-user"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-delete-addition-user-content">
                    
                    {trI18n('USER09MSG006')}
                    
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    onClick={handleAgree}
                    autoFocus
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    onClick={handleDisagree}
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
